import { FC } from 'react';
import { Button, Modal } from '../../../shared/ui';
import { useDispatch, useSelector } from 'react-redux';
import { aiModel } from '../model';
import { AI_ERROR_MAP } from '@distribute/shared/ai';

export const AIErrorModal: FC = () => {
  const dispatch = useDispatch();
  const error = useSelector(aiModel.selectors.selectError);

  const handleClose = () => {
    dispatch(aiModel.actions.setError(null));
  };

  if (!error) {
    return null;
  }

  return (
    <Modal
      isOpen
      onClose={handleClose}
      title={AI_ERROR_MAP[error].title}
      isShowCancelButton={false}
      actionButton={
        <Button fullWidth color="primary" variant="text" onClick={handleClose}>
          Got it
        </Button>
      }
    >
      <div className="text-sm text-gray-700">
        {AI_ERROR_MAP[error].description}
      </div>
    </Modal>
  );
};
